import React, { useContext } from 'react';
import isClient from '../helpers/environment';
import { headersIncidateSearchEngine } from '../../server/service/detect';

export type SeoContextType = { isSearchEngineRequest: boolean };
const SeoContext = React.createContext<SeoContextType>(null!);

export const SeoProvider = SeoContext.Provider;

const useSeo = () => {
    const context = useContext(SeoContext);
    if (!isClient()) {
        return context;
    }

    const isSearchEngineRequest = headersIncidateSearchEngine({
        'user-agent': navigator.userAgent,
        referer: document.referrer,
    });
    return { isSearchEngineRequest };
};

export default useSeo;
